//  authMiddleware.js
//
//  Updated 1/25.
//
//  Abstract: Check for authentication token on '/' [dashboard] routes.

export const authMiddleware = (history) => {
    const authToken = localStorage.getItem('AuthToken');
    if( authToken === null) {
        history.push('/login')
    }
}